// @flow
import styled from "styled-components";

export const Spacer = styled.div`
     {
        height: 25px;
    }
`;

export const LoadingBlogs = styled.div`
    text-align: center;
    padding: 20px;
`;



// WEBPACK FOOTER //
// ./src/home-page-view/blog-card-list/styled.js